import Image from 'next/image'

import Icons from '@/shared/components/icon/Icons'
import { Caption, Text } from '@/shared/components/typography'

interface CoverHeaderProps {
  title: string
  onBackClick?: () => void
  onCloseClick?: () => void
  onTextClick?: () => void
  text?: string
}

const ProcessHeader = ({ title, onBackClick, onCloseClick, onTextClick, text }: CoverHeaderProps) => {
  return (
    <div className="sticky top-0 flex h-[56px] w-full items-center justify-between bg-010 px-4 py-4">
      <div className="flex gap-2">
        {onBackClick && (
          <div className="cursor-pointer" onClick={onBackClick}>
            <Icons.BackIcon stroke="currentColor" color="#263238" />
          </div>
        )}
        <Text level="text3" color="text090">
          {title}
        </Text>
      </div>
      {onCloseClick && (
        <div className="cursor-pointer" onClick={onCloseClick}>
          <Image src={'/icons/light_icn_close_24.svg'} width={18} height={18} alt={'닫기아이콘'} className="h-6 w-6" />
        </div>
      )}
      {text && (
        <div className="cursor-pointer" onClick={onTextClick}>
          <Caption level="caption2" color="text090">
            {text}
          </Caption>
        </div>
      )}
    </div>
  )
}

export default ProcessHeader
